import Post1 from "../components/BlogPost/Post1";
import Post2 from "../components/BlogPost/Post2";
import Post3 from "../components/BlogPost/Post3";
import Post4 from "../components/BlogPost/Post4";
import Post5 from "../components/BlogPost/Post5";
import Post6 from "../components/BlogPost/Post6";
import Post7 from "../components/BlogPost/Post7";
import Post8 from "../components/BlogPost/Post8";
import Post9 from "../components/BlogPost/Post9";
import Post10 from "../components/BlogPost/Post10";
import Post11 from "../components/BlogPost/Post11";
import Post12 from "../components/BlogPost/Post12";


export const postRoutes = [
  { slug: "ia-sst", title: "IA y SST", component: <Post1 /> },
  { slug: "analisis-predictivo-sst", title: "Análisis Predictivo", component: <Post2 /> },
  { slug: "chatgpt-sst", title: "Cómo Usar ChatGPT para SST: 15 Prompts Que Todo Profesional Debe Conocer", component: <Post3 /> },
  { slug: "automatizacion-sst", title: "Automatización de Procesos en Seguridad Laboral: Mi Metodología Probada en +50 Empresas", component: <Post4 /> },
  { slug: "7-herramientas-ia-para-sst", title: "Las 7 Mejores Herramientas de IA que Están Revolucionando la Productividad en SST", component: <Post5 /> },
  { slug: "roi-ia-sst", title: "ROI de la IA en SST: Cómo Medí un 300% de Aumento en Eficiencia", component: <Post6 /> },
  { slug: "Transformacion-digital-ia-sst", title: "Supervisores vs IA", component: <Post7 /> },
  { slug: "errores-fatalas-al-implementar-inteligencia-artificial-en-seguridad-y-salud-en-el-trabajo", title: "Checklist con IA", component: <Post8 /> },
  { slug: "el-futuro-de-la-ia-en-la-seguridad-y-salud-en-el-trabajo", title: "El Futuro de la IA en SST: Predicciones para 2025-2030", component: <Post9 /> },
  { slug: "mi-viaje-transformando-empresas-con-sst", title: "De Tradicional a Digital: Mi Journey Transformando Empresas con IA en SST", component: <Post10 /> },
  { slug: "primer-taller-iasst", title: "Primer taller de IA para SST en latinoamerica", component: <Post11 /> },
  { slug: "", title: "", component: <Post12 /> },
];
